import styled from 'styled-components';
import React, { ReactNode } from 'react';

interface ArticleCardSumaryProps {
  children?: ReactNode;
  className?: string;
}

function ArticleCardSumary({ children, className }: ArticleCardSumaryProps) {
  return (
    <ArticleCardSummaryCss className={className}>
      {children}
    </ArticleCardSummaryCss>
  );
}

const ArticleCardSummaryCss = styled.p`
  ${p => p.theme.getFontStyle('primary', 'medium')}
  font-size: ${p => p.theme.typography.textSm2};
  color: ${p => p.theme.articleCard.summaryColor};
  line-height: 1.46;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default ArticleCardSumary;
